module.exports = __webpack_public_path__ + "img/bsiva-light.7da3b12e.png";